const messages = {
    valid_username: 'Please Enter Valid Username',
    valid_password: 'Please Enter Valid Password',
};

export default messages;
